import Footer from './Footer';
import Nav from './Nav';
import Layout from './Layout';

export default {
  Nav,
  Layout,
  Footer
};



// WEBPACK FOOTER //
// ./docs/lib/UI/index.js